<template>
  <v-row wrap>
    <v-col sm="6">
      <v-progress-circular indeterminate color="orange-darken-2" v-show="preLoading" :size="70" :width="4"></v-progress-circular>
      <RentalSupplierForm
        :rentalSupplier="rentalSupplier"
        :submit="submit"
        :title="t('rentalSupplierEdit') + ' ' + rentalSupplier.name"
        :onInput="onInput"
        :loading="loading"
        :buttonText="t('save')"
        :customRules="rules"
        v-if="!preLoading"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref, onUnmounted, defineComponent, computed, onBeforeMount, watch, nextTick } from 'vue'
import { default as RentalSupplierForm } from './Form.vue'
import Say from '@/utils/Say'
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import sayErrorResponse from '@/mixins/sayErrorResponse'

defineComponent({
  RentalSupplierForm
})

const { t } = useI18n()
const route = useRoute()
const store = useStore()

const preLoading = ref(true)
const loading = ref(false)

const rules = {
  password: [
    (v: any) => (v.length === 0 || v.length >= 6) || t('validationPasswordMinLength')
  ],
  pincode: [
    (v: any) => (v.length === 0 || v.length === 4) || t('validationPincodeExactlyFour'),
    (v: any) => (v.length === 0 || /^\d+$/.test(v)) || t('validationPincodeNumbersOnly')
  ]
}

const rentalSupplier = computed(() => {

  return store.getters.rentalSupplierEdit
})

watch(store.getters.rentalSupplierEdit, () => {
  if(store.getters.rentalSupplierEdit.name !== '') {
    preLoading.value = false
  }
}),

onBeforeMount(() => {
  // UI
  store.commit('app.setPageTitle', t('edit') + ' ' + store.getters.rentalSupplierEdit.name)
  store.commit('app.setBreadcrumbs', [
    { text: t('rentalSupplier', 2), routeName: 'RentalSuppliers' },
    { text: t('edit') + ' ' + store.getters.rentalSupplierEdit.name }
  ])
  store.dispatch('rentalSuppliers.getSingleForEdit', route.params.id)
})

onUnmounted(() => {
  store.commit('rentalSuppliers.editClear')
})

const submit = () => {
  loading.value = true
  store.dispatch('rentalSuppliers.edit').then(() => {
    // Display success
    loading.value = false
    Say('success', t('rentalSupplierEditSuccess'))
  }).catch((err) => {
    // Validation error
    loading.value = false
    sayErrorResponse(err)
  })
}

const onInput = (name: string, value: any) => {
  store.commit('rentalSuppliers.editUpdateInput', { name: name, value: value })
}
</script>
